import { render, staticRenderFns } from "./ModularProfessionPage.vue?vue&type=template&id=24e60fbd"
import script from "./ModularProfessionPage.vue?vue&type=script&lang=js"
export * from "./ModularProfessionPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports